import React from 'react';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-charcoal text-white pt-20 pb-10" data-id="element-62">
      <div className="container mx-auto px-6" data-id="element-63">
        {/* Top Row */}
        <div className="flex flex-col md:flex-row items-center justify-between border-b border-white/10 pb-12 mb-12 text-center md:text-left" data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/nTXeUnc9Lw2NVzZWLxEVDq/Rance-Realty-Demo-logo.png" alt="Rance Realty Logo" className="h-12 brightness-0 invert mb-6 md:mb-0" data-id="element-65" />
          <p className="font-heading uppercase tracking-widest text-gold text-sm" data-id="element-66">
            Elevating Your Real Estate Experience.
          </p>
        </div>

        {/* Middle Row */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 text-center md:text-left mb-16" data-id="element-67">
          {/* Quick Links */}
          <div data-id="element-68">
            <h4 className="font-heading uppercase tracking-widest text-sm font-semibold mb-6 text-white" data-id="element-69">
              Quick Links
            </h4>
            <ul className="space-y-4 font-body text-white/70" data-id="element-70">
              <li data-id="element-71">
                <a href="#" className="hover:text-gold transition-colors" data-id="element-72">
                  Home
                </a>
              </li>
              <li data-id="element-73">
                <a href="#about" className="hover:text-gold transition-colors" data-id="element-74">
                  About
                </a>
              </li>
              <li data-id="element-75">
                <a href="#listings" className="hover:text-gold transition-colors" data-id="element-76">
                  Listings
                </a>
              </li>
              <li data-id="element-77">
                <a href="#services" className="hover:text-gold transition-colors" data-id="element-78">
                  Services
                </a>
              </li>
              <li data-id="element-79">
                <a href="#contact" className="hover:text-gold transition-colors" data-id="element-80">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-81">
            <h4 className="font-heading uppercase tracking-widest text-sm font-semibold mb-6 text-white" data-id="element-82">
              Contact Info
            </h4>
            <ul className="space-y-4 font-body text-white/70" data-id="element-83">
              <li data-id="element-84">(555) 123-4567</li>
              <li data-id="element-85">nathan@rancerealty.com</li>
              <li data-id="element-86">
                100 Luxury Lane, Suite 400
                <br data-id="element-87" />
                Beverly Hills, CA 90210
              </li>
            </ul>
          </div>

          {/* Social Icons */}
          <div className="flex flex-col items-center md:items-start" data-id="element-88">
            <h4 className="font-heading uppercase tracking-widest text-sm font-semibold mb-6 text-white" data-id="element-89">
              Follow Us
            </h4>
            <div className="flex items-center gap-4" data-id="element-90">
              <a href="#" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gold hover:text-charcoal transition-all duration-300" data-id="element-91">
                <Facebook className="h-5 w-5" data-id="element-92" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gold hover:text-charcoal transition-all duration-300" data-id="element-93">
                <Instagram className="h-5 w-5" data-id="element-94" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gold hover:text-charcoal transition-all duration-300" data-id="element-95">
                <Linkedin className="h-5 w-5" data-id="element-96" />
              </a>
              <a href="#" className="h-10 w-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-gold hover:text-charcoal transition-all duration-300" data-id="element-97">
                <Youtube className="h-5 w-5" data-id="element-98" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/10 font-body text-xs text-white/50 text-center md:text-left gap-4" data-id="element-99">
          <p data-id="element-100">&copy; 2026 Rance Realty. All Rights Reserved.</p>
          <div className="flex items-center gap-4" data-id="element-101">
            <a href="#" className="hover:text-white transition-colors" data-id="element-102">
              Privacy Policy
            </a>
            <span data-id="element-103">|</span>
            <a href="#" className="hover:text-white transition-colors" data-id="element-104">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}